module.exports = __webpack_public_path__ + "static/media/General.c80e66e3.md";